<template>
  <VSection label="autotopupregistrations.registration_error_headline">
    <VDescriptionListDividedHorizontal>
      <VEntry :data="errorData" field="errorStatus" name="autotopupregistrations.registration_error_status_label" />
      <VEntry :data="errorData" field="errorDetail" name="autotopupregistrations.registration_error_detail_label" mandatory />
      <VEntry
        v-if="showDetailTranslation"
        :value="$to(`autotopupregistrations.registration_error_translated_detail_${errorData.errorStatus}`)"
        name="autotopupregistrations.registration_error_translated_detail_label"
      />
    </VDescriptionListDividedHorizontal>
  </VSection>
</template>

<script>
import VSection from '@/components/Section';
import VDescriptionListDividedHorizontal from '@/components/DescriptionList/DividedHorizontal';
import VEntry from '@/components/DescriptionList/Entry';

export default {
  name: 'AutoTopUpRegistrationDetailsFailed',

  components: {
    VSection,
    VDescriptionListDividedHorizontal,
    VEntry,
  },

  props: {
    errorData: {
      type: Object,
      required: true,
    },
  },

  computed: {
    showDetailTranslation() {
      return this.errorData.errorStatus && this.$te(`autotopupregistrations.registration_error_translated_detail_${this.errorData.errorStatus}`);
    },
  },
};
</script>
